
module.filter('autoSortName', function() {
    return function(name) {
        if (!name) { return "";}

        var parts = name.split(" ");
        if (parts.length <= 1) {
            return name;
        } else {
            return parts[parts.length - 1] + ", " + parts.slice(0, -1).join(' ');
        }
    };
});